import ApiCore from "./ApiCore";
import {IData} from "../constants/interfaces";
import { getDashboardListOrder } from "./apiHelper";

/**
 * All API End-points
 */
class AdminApi {
    api: ApiCore;
    constructor(baseUrl = "") {
        this.api = new ApiCore();

        if (baseUrl) {
            this.api.setBaseUrl(baseUrl);
        }
    }

    /**
     * @returns {Promise<*>}
     */
    getBrands() {
        return this.api.get(`/api/brands/list?brandId=${this.api.getBrandId()}`);
    }

	/**
     * @returns {Promise<*>}
     */
    getBigscreenSettings() {
		const rand = Math.random();

		return this.api.get('/api/bigscreen/settings', {
			brandId: this.api.getBrandId(),
			randd: rand,
		}, true);
    }

    /**
     * @returns {Promise<*>}
     */
	getReferrers(brands: string, search: string) {
        return this.api.get(`/api/brands/referrer/list?brandId=${this.api.getBrandId()}&brands=${brands}&search=${search}`);
    }

	/**
	 * @returns {Promise<*>}
	 */
	getReferrerTypes(brands: string) {
		return this.api.get(`/api/brands/referrer_type/list?brandId=${this.api.getBrandId()}&brands=${brands}`);
	}

    /**
     * @returns {Promise<*>}
     */
    getSections(brands: string, type: string, search: string) {
		return this.api.get(`/api/brands/section/list?brandId=${this.api.getBrandId()}&brands=${brands}&type=${type}&search=${search}`);
    }

	/**
	 * @returns {Promise<*>}
	 */
    getSegments(brands: string, type: string) {
        return this.api.get(`/api/brands/segment/list?brandId=${this.api.getBrandId()}&brands=${brands}&type=${type}`);
    }

	/**
	 * @returns {Promise<*>}
	 */
	getChannels() {
    	return this.api.get(`/api/brands/channel/list?brandId=${this.api.getBrandId()}`)
	}

	/**
     * @returns {Promise<*>}
     */
    getTags(brands: string, type: string, search: string) {
        return this.api.get(`/api/brands/tag/list?brandId=${this.api.getBrandId()}&brands=${brands}&type=${type}&search=${search}`);
    }

	/**
	 * @returns {Promise<*>}
	 */
	getConversions(brands: string, topResults: boolean) {
		return this.api.get(`/api/brands/conversion/list?brandId=${this.api.getBrandId()}&brands=${brands}` + (topResults ? '&topResults=1' : ''));
	}

	/**
	 * @returns {Promise<*>}
	 */
	getDashboards(sort: string = "description", order: string = "asc", search?: string, page?: number, limit?: number) {
		const params: any = {
			brandId: this.api.getBrandId(),
			randd: Math.random(),
			order: getDashboardListOrder(`${sort}.${order}`)
		};

		if (search) {
			params.search = search;
		}

		if (page) {
			params.page = page;
		}
		
		if (limit) {
			params.limit = limit;
		}

		return this.api.get('/api/bigscreen/list', params, true);
	}

	/**
	 * @param data
	 * @returns {Promise<*>}
	 */
	saveDashboard(data: IData) {
		return this.api.jsonPost(`/api/bigscreen/add?brandId=${this.api.getBrandId()}`, data).then(response => response.data);
	}

	/**
	 * @param id
	 * @returns {Promise}
	 */
	deleteDashboard(id: string | number) {
		return this.api.delete(`/api/bigscreen/${id}/?brandId=${this.api.getBrandId()}`)
	}

	/**
	 *
	 * @param id
	 * @param data
	 * @returns {Promise<*>}
	 */
	updateDashboard(id: string | number, data: IData) {
		return this.api.jsonPost(`api/bigscreen/update/${id}/?brandId=${this.api.getBrandId()}`, data).then(response => response.data);
	}

	authenticateUser() {
		return this.api.get(`/api/auth/check/${this.api.getBrandId()}`);
	}

	getGoals() {
		return this.api.get(`/api/brands/${this.api.getBrandId()}/goals/list`, true)
	}

	/**
	* @param id
	*/
	getGoalArchive(id: string, page?: number) {
		const params: any = {};

		if (page) {
			params.page = page;
		}

		return this.api.get(`/api/brands/${this.api.getBrandId()}/goals/archive/${id}`, params);
	}

	/**
	 *
	 * @param id
	 */
	getGoalConfiguration(id: string) {
		return this.api.get(`/api/brands/${this.api.getBrandId()}/goals/configuration/${id}`);
	}

	async saveGoal(data: IData): Promise<any> {
		const response = await this.api.jsonPost(`/api/brands/${this.api.getBrandId()}/goals`, data);
		return response.data;
	}

	deleteGoal(id?: string | number): Promise<any> {
		return this.api.delete(`/api/brands/${this.api.getBrandId()}/goals/${id}`)
	}

	/**
	 *
	 * @param id
	 * @param data
	 * @returns {Promise<*>}
	 */
	async updateGoal(id: string | number, data: IData): Promise<any> {
		const response = await this.api.jsonPost(`/api/brands/${this.api.getBrandId()}/goals/${id}`, data);
		return response.data;
	}

} // end class

export default AdminApi;
